<template>
  <div>
    <PCNavbar selectIndex="6"/>
    <MobileNavBar :currentActive="7" />
    <ITHardware />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ITHardware from '@/components/iTHardware/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,ITHardware

  },
}
</script>

<style lang="css">
.it_hardware_inner {
  display: flex;
  justify-content: center;
  .inner_center {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 50px;
    @media screen and (max-width: 768px) {
      flex: 2.2;
    }
    .it_hardware_title {
      color: #05102F;
      font-size: 33px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
        margin-bottom: 10PX;
      }
    }
    .it_hardware_desc {
      font-size: 16px;
      color: #253554;
      margin-top: 10px;
      @media screen and (max-width: 768px) {
      //margin-top: 10PX;
        font-size: 0.8rem;
      }
    }
  }
}
.it_hardware_img {
  width: 100%;
  height: 420px;
  color: #fff;
  display: flex;
  align-items: start;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    height: 40vw;
    padding-left: 10PX;
  }
  .img_tit {
    font-size: 40px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 10PX;
    }
  }
  .img_desc {
    font-size: 24px;
    margin-top: 20px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      margin-bottom: 8PX;
    }
  }
  .img_btn {
    width: 150px;
    height: 40px;
    margin-top: 20px;
    background: #00A4FF;
    color: #fff !important;
    bottom: 15%;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.5s;
    font-size: 14px;
    &:hover {
      color: #fff;
      font-weight: bold;
      background: #24b1ff;
    }
    @media screen and (max-width: 768px) {
      width: 70PX;
      height: 24PX;
      border-radius: 2PX;
      font-size: 0.6rem;
    }
  }
}
</style>